export const scrollResultsToTop = () => {
  // On filter apply - scroll results to top (but without TopBanner/Launches)
  const offset = 10;
  const topImagesWrapper = document.getElementById('top_images_wrapper');
  const topImagesHeight = topImagesWrapper?.offsetHeight || 0;
  window.scrollTo(0, window.scrollY !== 0 ? topImagesHeight + offset : 0);
  window.dispatchEvent(new CustomEvent('windowScrollUpdated'));
};
